import {Component, Input, OnInit,} from '@angular/core';
import {TranslocoService} from '@ngneat/transloco';
import {Country, EventItem, Lookups} from "@model";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {LiveResultHeadingType} from "../live-results-race-heading/live-results-race-heading.component";
import {AbstractComponent} from "../abstract.component";
import {LocalStorageService} from "@services";


@Component({
    selector: 'app-live-event',
    templateUrl: './live-event.component.html',
    styleUrls: ['./live-event.component.scss'],
    animations: [
        trigger('toBottom', [
            state('in', style({ height: '*' })),
            transition(':enter', [
                style({ height: '0', overflow: 'hidden' }),
                animate('300ms ease-out', style({ height: '*' }))
            ]),
            state('out', style({ height: '0' })),
            transition(':leave', [
                style({ height: '*', overflow: 'hidden' }),
                animate('300ms ease-out', style({ height: '0' }))
            ])
        ])
    ],
    standalone: false
})
export class LiveEventComponent extends AbstractComponent implements OnInit {

  @Input() liveEvent: EventItem | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) countries: Country[] = [];

  isExpanded: boolean = false;

  constructor(public translocoService: TranslocoService, private localStorageService: LocalStorageService) {
    super();
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.isExpanded = this.localStorageService.getData("liveEventExpanded-" + this.liveEvent?.id) === "true";
    }
  }

  expand() {
    this.isExpanded = !this.isExpanded;
    if (this.isBrowser) {
      this.localStorageService.saveData("liveEventExpanded-"+ this.liveEvent?.id, this.isExpanded.toString());
    }
  }


  protected readonly LiveResultHeadingType = LiveResultHeadingType;
}
